export default "__VITE_ASSET__DkaM8aiu__"